import { createBrowserHistory } from "history";

// configure, create, and export the project's history instance
export const history = createBrowserHistory();
